import { useEffect, useMemo, useState } from "react";
import { api } from "../../api/client";
import { useAuth } from "../../context/AuthContext";
import "../../style/pages.css";
import "./Board.css";

export default function Board() {
  const { csrfToken } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filter, setFilter] = useState("전체");
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ type: "일반", title: "", content: "", urgent: false });

  useEffect(() => {
    api.getPosts().then(setPosts).catch((reason) => setError(reason.message)).finally(() => setLoading(false));
  }, []);

  const visiblePosts = useMemo(() => filter === "전체" ? posts : posts.filter((post) => post.type === filter), [posts, filter]);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSaving(true);
    try {
      const created = await api.createPost(form, csrfToken);
      setPosts((current) => [created, ...current]);
      setForm({ type: "일반", title: "", content: "", urgent: false });
      setOpen(false);
    } catch (reason) {
      setError(reason.message);
    } finally { setSaving(false); }
  };

  return (
    <div>
      <header className="page-head"><div><p className="eyebrow">SURVIVOR CHANNEL / DELAY 318MS</p><h1>생존자 게시판</h1></div><button type="button" className="primary-button" onClick={() => setOpen(true)}>새 기록 작성</button></header>
      <div className="board-notice">! 긴급 구조 요청은 위치 정보가 노출될 수 있습니다. 현재 안전이 확보된 단말에서만 작성하십시오.</div>
      <div className="board-filter" aria-label="게시판 분류">
        {["전체", "일반", "구조 요청", "물자 교환", "실종자", "정찰 보고"].map((type) => <button key={type} type="button" className={filter === type ? "active" : ""} onClick={() => setFilter(type)}>{type}</button>)}
      </div>
      {error && <div className="board-error" role="alert">! {error}</div>}
      <section className="post-list panel">
        <div className="post-head"><span>분류</span><span>기록</span><span>작성자</span><span>수신</span></div>
        {loading && <div className="board-empty">기록 수신 중...</div>}
        {!loading && visiblePosts.map((post) => <article className={post.urgent ? "urgent" : ""} key={post.id}><div><span className="status-tag">{post.type}</span></div><div><h2>{post.urgent && <b>[긴급]</b>} {post.title}</h2><p>{post.content}</p></div><strong>{post.author}</strong><time>{post.createdAt}</time></article>)}
        {!loading && !visiblePosts.length && <div className="board-empty">해당 분류의 기록이 없습니다.</div>}
      </section>
      {open && <div className="modal-backdrop" role="presentation" onMouseDown={() => setOpen(false)}><section className="compose-modal panel" role="dialog" aria-modal="true" aria-labelledby="compose-title" onMouseDown={(event) => event.stopPropagation()}><div className="modal-head"><div><p className="eyebrow">NEW TRANSMISSION</p><h2 id="compose-title">새 기록 전송</h2></div><button type="button" onClick={() => setOpen(false)}>×</button></div><form onSubmit={submit}><div className="field"><label htmlFor="post-type">분류</label><select id="post-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}><option>일반</option><option>구조 요청</option><option>물자 교환</option><option>실종자</option><option>정찰 보고</option></select></div><div className="field"><label htmlFor="post-title">제목</label><input id="post-title" maxLength="120" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div><div className="field"><label htmlFor="post-content">내용</label><textarea id="post-content" rows="6" maxLength="2000" required value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} /></div><label className="urgent-check"><input type="checkbox" checked={form.urgent} onChange={(e) => setForm({ ...form, urgent: e.target.checked })} /> 긴급 기록으로 표시</label><button className="primary-button" disabled={saving}>{saving ? "전송 중..." : "기록 전송"}</button></form></section></div>}
    </div>
  );
}
